module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "fmb"
  }, [_c('h2', {
    staticClass: "fmtitle"
  }, [_vm._v("acknowledgments")])]), _vm._v(" "), _c('div', {
    staticClass: "fmbr"
  }, [_c('p', {
    staticClass: "noindentw"
  }, [_vm._v("I’d like to thank Gayle Ronconi for her perfect piecing of the quilts, the members of the C&T Publishing editorial department for their ideas and inspiration, and the following companies for providing the wonderful buttons and fabrics used in the quilts:")]), _vm._v(" "), _c('p', {
    staticClass: "noindentw"
  }, [_vm._v("Dill Buttons")]), _vm._v(" "), _c('p', {
    staticClass: "noindentw"
  }, [_vm._v("Freespirit Fabrics")]), _vm._v(" "), _c('p', {
    staticClass: "noindentw"
  }, [_vm._v("Westminster Fabrics")]), _vm._v(" "), _c('p', {
    staticClass: "noindentw"
  }, [_vm._v("Timeless Treasures Fabrics")]), _vm._v(" "), _c('p', {
    staticClass: "noindentw"
  }, [_vm._v("RJR Fabrics")]), _vm._v(" "), _c('p', {
    staticClass: "noindentw"
  }, [_vm._v("P&B Textiles")]), _vm._v(" "), _c('p', {
    staticClass: "noindentw"
  }, [_vm._v("Quilters Dream Batting")]), _vm._v(" "), _c('p', {
    staticClass: "noindentw"
  }, [_vm._v("Presencia Threads")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-68f848e4","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/03_Acknowledgments.vue
// module id = 63
// module chunks = 0